<template>
  <div :class="$style['showcase-wrap']">
    <video ref="showcaseVideo" :src="videoSrc" controls playsinline />
    <button @click="playVideo" v-show="!isPlaying">
      <img :src="videoPoster" />
    </button>
  </div>
</template>

<script>
export default {
  name: "ShowcaseVideo",
  props: {
    videoSrc: {
      type: String,
      default: ""
    },
    videoPoster: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      isPlaying: false
    };
  },
  methods: {
    playVideo() {
      const video = this.$refs.showcaseVideo;
      if (video) {
        video
          .play()
          .then(() => {
            this.isPlaying = true;
          })
          .catch(error => {
            console.error("视频播放失败:", error);
          });
      }
    }
  }
};
</script>

<style lang="less" module>
.showcase-wrap {
  .size(9.57rem, 5.35rem);

  position: relative;
  margin: 0 auto;

  video,
  img {
    .size(100%);

    border-radius: 0.6rem;
    background-color: #000;
  }

  button {
    .size(100%);

    position: absolute;
    top: 0;
    left: 0;

    &::after {
      content: "";
      .size(1.43rem, 1.48rem);
      .background-fill("./images/showcase-btn.png");

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      animation: breath 2s infinite ease-in-out;
    }
  }

  @keyframes breath {
    0%,
    100% {
      transform: translate(-50%, -50%) scale(1);
    }
    50% {
      transform: translate(-50%, -50%) scale(1.1);
    }
  }

  &::after {
    .size(10.55rem, 6rem);
    .background-fill("./images/showcase-border.png");

    z-index: 1;
    content: "";
    position: absolute;
    top: -0.23rem;
    left: -0.54rem;
    pointer-events: none;
  }
}
</style>
